angular.module('tf.services')

    .factory('ScheduleService', ['HttpService','$q','$uibModal','ProjectService',
        function (HttpService, $q, $uibModal, ProjectService) {

            var service = {};

            service.get = function(){
                return HttpService.get('schedule');
            };
            service.set = function(project, startDate, interval, repeat){
                return HttpService.post("schedule", {project : project, start_date : startDate, interval : interval, repeat : repeat});
            };

            service.getSchedule = function(project){
                return HttpService.get("schedule", {pid : project.id, fid : project.fid});
            };

            service.createSchedule = function(project, schedule){
                return HttpService.post("schedule", angular.extend({},{project : project}, schedule));
            };

            service.editSchedule = function(){

            };

            service.deleteSchedule = function(project){
                return HttpService.post("schedule", {project : project});
            };

            service.openScheduler = function(path){

                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'js/components/scheduler/scheduler.html',
                    controller: 'ScheduleController',
                    size: 'lg',
                    windowTopClass : 'schedule-modal',
                    backdrop : 'static',
                    resolve: {
                        project: function () {
                            return ProjectService.loadProject(path);
                        }
                    }
                });
            };



            return service;
        }])
;
